<template>
    <el-row>
        <div class="nav-header">
            <div class="logo"></div>
            <div class="title">接口文档</div>
        </div>
        <el-col>
            <el-menu
                    :unique-opened="true"
                    :default-active="active"
                    background-color="#23262c"
                    text-color="#b8c7ce"
                    active-text-color="#46a0fc"
            >

                <!--<router-link  to="/home">-->
                    <!--<el-menu-item index="999+''">-->
                        <!--<span slot="title">总览</span>-->
                    <!--</el-menu-item>-->
                <!--</router-link>-->

                    <router-link v-for="item in submenu" :key="item.path" :to="item.path">
                        <el-menu-item :index="item.path">{{ item.meta.title}}</el-menu-item>
                    </router-link>
            </el-menu>
        </el-col>
    </el-row>
</template>

<script>
    import bus from "../assets/js/EventBus";
    import router from '../router'
    export default {
        name: "Nav",
        data() {
            return {
                active: "1",
                        submenu:[
                        ]
            };
        },
        created() {
            this.active = this.$route.path;
            bus.$on("PushPage", e => {
                this.active = e.path;
            });
            let ary=router.options.routes;
            ary.forEach(item=>{
                if(item.path.indexOf('api')>-1){
                    this.submenu.push(item);
                }
            })

        },
        methods: {

        },
    };
</script>

<style scoped>
    .nav-header {
        width: 100%;
        height: 50px;
        background-color: rgb(35, 38, 44);
        display: flex;
        align-items: center;
    }

    .logo {
        width: 109px;
        height: 31px;
        background: url("../assets/img/logo.png");
        margin-left: 22px;
    }

    .title {
        height: 20px;
        line-height: 20px;
        padding-left: 5px;
        margin-left: 5px;
        border-left: 1px solid #fff;
        color: #fff;
        font-size: 18px;
    }

    .el-menu {
        width: 100%;
    }

    .txt-1 {
        color: #fff;
        margin-right: 5px;
    }

    .el-menu-item {
        border-left: 1px transparent solid;
    }

    .el-menu-item.is-active {
        border-left: 1px #2479f0 solid;
    }

    .is-opened >>> .el-submenu__title {
        background-color: #000 !important;
    }
</style>
